"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgNothroughTraffic(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "5 0 14 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M19 7V4H5v3h14zm-5.5 13V8h-3v12h3z" })));
}
exports.default = tombacIcon_1.default('NothroughTraffic')(SvgNothroughTraffic);
//# sourceMappingURL=NothroughTraffic.js.map